import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export default function (impact = ImpactStyle.Medium) {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable("Haptics")) return;

  return Haptics.impact({
    style: impact,
  });
}
